module.exports = __webpack_public_path__ + "img/github.aae07e08.svg";